import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import * as Styled from './styles';
import * as fromRoutes from 'routes';
import { ReactComponent as HomeIcon } from 'assets/icons/home.svg';
import { ReactComponent as RocketIcon } from 'assets/icons/rocket.svg';

const SideBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Styled.Wrapper isVisible={isVisible}>
      <Styled.Toggle
        isVisible={isVisible}
        onClick={() => setIsVisible(!isVisible)}>
        <Styled.Span isVisible={isVisible} />
        <Styled.Span isVisible={isVisible} />
        <Styled.Span isVisible={isVisible} />
      </Styled.Toggle>
      <NavLink to='/'>
        <Styled.Logo src={require('assets/images/logo.jpg')} />
      </NavLink>
      <Styled.Link
        to='/'
        exact={true}
        activeClassName='active'
        onClick={() => setIsVisible(!isVisible)}>
        <HomeIcon width={18} id='home' />
        <span>Home</span>
      </Styled.Link>
      <Styled.Link
        to='/example'
        activeClassName='active'
        onMouseOver={() => fromRoutes.AsyncExample.preload()}
        onClick={() => setIsVisible(!isVisible)}>
        <RocketIcon width={18} id='example' />
        <span>Example</span>
      </Styled.Link>
    </Styled.Wrapper>
  );
};

export default SideBar;
